import { lazy } from "react";
import { BookOpen, Mail, User, Compass, Repeat, Send } from "react-feather";
import AcceptInvite from "@/pages/public/AcceptInvite";
import AcceptReferral from "@/pages/public/AcceptReferral";
import LoginAndJoinTeam from "@/pages/public/LoginAndJoinTeam.js";

const Learn = lazy(() => import("@/pages/private/Learn"));
const Profile = lazy(() => import("@/pages/private/Profile"));
const Review = lazy(() => import("@/pages/private/Review"));
const Explore = lazy(() => import("@/pages/private/Explore"));
const Leaderboards = lazy(() => import("@/pages/private/Leaderboards"));
const DeleteAccount = lazy(
  () => import("@/pages/private/DeleteAccountWithAuth.js"),
);
const Contact = lazy(() => import("@/pages/private/Contact"));
const Invite = lazy(() => import("@/pages/private/Invite"));
const Company = lazy(() => import("@/pages/private/BrandOverview"));
const Login = lazy(() => import("@/pages/public/Login"));
const Register = lazy(() => import("@/pages/public/Register"));
const ForgotPassword = lazy(() => import("@/pages/public/ForgotPassword"));
const Certification = lazy(() => import("@/pages/private/Certification"));

export const sidebarRoutes = [
  {
    name: "Learn",
    icon: BookOpen,
    url: "/",
    children: false,
  },

  {
    name: "Explore",
    icon: Compass,
    url: "explore",
    children: false,
  },
  {
    name: "Review",
    children: false,
    url: "review",
    icon: Repeat,
  },
  {
    name: "Profile",
    icon: User,
    url: "/profile",
    children: false,
  },
  {
    name: "Invite a friend",
    children: false,
    url: "invite",
    icon: Send,
  },
  {
    name: "Contact us",
    children: false,
    url: "contact",
    icon: Mail,
  },
];

export const protectedRoutes = [
  {
    name: "Learn Feed",
    shouldSuspend: true,
    path: "/",
    component: Learn,
  },
  {
    name: "Review",
    component: Review,
    shouldSuspend: true,
    path: "review/",
  },
  {
    name: "Explore",
    component: Explore,
    shouldSuspend: true,
    path: "explore/",
  },
  {
    name: "Profile",
    component: Profile,
    shouldSuspend: true,
    path: "profile/",
  },
  {
    name: "Brand Overview",
    component: Company,
    shouldSuspend: true,
    path: "company/:id",
  },
  {
    name: "Invite A Friend",
    component: Invite,
    shouldSuspend: true,
    path: "invite/",
  },
  {
    name: "Contact Us",
    component: Contact,
    shouldSuspend: true,
    path: "contact/",
  },
  {
    name: "Leaderboards",
    component: Leaderboards,
    shouldSuspend: true,
    path: "leaderboards/",
  },
  {
    name: "Delete Account",
    component: DeleteAccount,
    shouldSuspend: true,
    path: "delete-personal-data/",
  },
  {
    name: "Certification",
    component: Certification,
    shouldSuspend: true,
    path: "certification/:certId",
  },
];

export const publicRoutes = [
  {
    name: "Login",
    shouldSuspend: true,
    path: "signin/",
    component: Login,
  },
  {
    name: "Register",
    shouldSuspend: true,
    path: "register/",
    component: Register,
  },
  {
    name: "Login And Join Team",
    shouldSuspend: false,
    path: "signin+join/",
    component: LoginAndJoinTeam,
  },
  {
    name: "Forgot Password",
    shouldSuspend: true,
    path: "forgot-password/",
    component: ForgotPassword,
  },
  {
    name: "Accept Invite",
    shouldSuspend: false,
    path: "invitation/:token",
    component: AcceptInvite,
  },
  {
    name: "Accept Referral",
    shouldSuspend: false,
    path: "referral/:token",
    component: AcceptReferral,
  },
];
